var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUpload = function SvgUpload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CAAF2",
    d: "M26.017 0H3.983C1.787 0 0 1.794 0 3.998v4.314c0 1.095.394 2.154 1.11 2.98l1.885 2.178a1.53 1.53 0 0 0 2.165.152c.64-.558.708-1.53.152-2.173L3.426 9.272a1.47 1.47 0 0 1-.357-.96V3.998c0-.506.41-.917.914-.917h22.034c.504 0 .914.411.914.917v4.314c0 .352-.127.693-.357.96l-1.886 2.177a1.544 1.544 0 0 0 .152 2.173 1.53 1.53 0 0 0 2.165-.152l1.885-2.177A4.55 4.55 0 0 0 30 8.312V3.998C30 1.794 28.213 0 26.017 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CAAF2",
    d: "M15.999 10.46c-.552-.613-1.446-.613-1.998 0l-6.587 7.331c-.552.614-.552 1.61 0 2.223.551.613 1.445.613 1.997 0l4.177-4.649V29.43c0 .867.632 1.571 1.412 1.571s1.412-.704 1.412-1.572V15.365l4.177 4.649c.276.307.638.46.999.46s.723-.153.998-.46c.552-.614.552-1.61 0-2.223z"
  })));
};
export default SvgUpload;